import * as React from 'react';
export const pricingPlanSvg = React.forwardRef(function pricingPlanSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.172 11.116c.364-.204.946-.198 1.298.012.353.21.343.547-.022.75L9.498 15.2c-.836.467-2.165.464-2.994-.007L.666 11.874c-.362-.205-.367-.541-.011-.75.356-.208.938-.211 1.3-.006l5.838 3.319a.482.482 0 0 0 .427 0l5.952-3.321Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.172 7.719c.364-.203.946-.198 1.298.013.353.21.342.546-.022.75l-5.95 3.321c-.836.467-2.165.463-2.994-.008L.666 8.478c-.362-.206-.367-.541-.011-.75.356-.209.938-.211 1.3-.006l5.838 3.317a.48.48 0 0 0 .427.001l5.952-3.321Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.484.725c.837-.483 2.194-.483 3.031 0l5.269 3.04c.837.484.837 1.268 0 1.75L9.515 8.559c-.837.483-2.194.483-3.03 0l-5.27-3.043c-.836-.483-.836-1.267 0-1.75L6.484.725Zm1.732.75a.479.479 0 0 0-.432 0l-5.269 3.04c-.119.07-.119.182 0 .25l5.269 3.043a.48.48 0 0 0 .432 0l5.269-3.042c.12-.07.12-.181 0-.25L8.216 1.475Z',
    }),
  );
});
pricingPlanSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pricingPlan = {
  category: 'icon',
  colorable: true,
  name: 'pricingPlan',
  svg: pricingPlanSvg,
};
